import src from "IMAGE";
export default { src, width: 284, height: 56, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ALGHV4duZFY/LS0tJ0hANkFnTTA3XUcvKkY2JCALCgkIALCGVYR0alxOQkJBX1NJPGyibzZmqnU7Y4tlOlY6OTc8hhIT+Im+9YcAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
